import { render, staticRenderFns } from "./Detail3.vue?vue&type=template&id=457c1f27&scoped=true&"
import script from "./Detail3.vue?vue&type=script&lang=js&"
export * from "./Detail3.vue?vue&type=script&lang=js&"
import style0 from "./Detail3.vue?vue&type=style&index=0&id=457c1f27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c1f27",
  null
  
)

export default component.exports